<template>
  <div>
    <Loader cover v-if="courseFaqProcessing || courseOutlineProcessing"/>

    <card-subject-info :classSectionId="$route.params.classSectionId" currentPage="COURSE_FAQ"></card-subject-info>

    <vx-card>

      <vs-table-mod :data="courseFaqs"
                    :max-items="tableConfig.maxItemsPerPage"
                    pagination
                    search
      >

        <template slot="header-left">
          <div class="vx-col md:w-1/3 sm:w-2/3">
            <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="courseOutlineUnits"
                      @input="onCourseOutlineUnitChange" class="mb-4 md:mb-0"
                      label="nameLocal"
                      selectOnTab
                      v-model="selectCourseOutlineUnit">

              <!--label option-->
              <template #selected-option="{ seq, nameLocal }">
                {{ seq }}. {{ nameLocal }}
              </template>

              <!--option list-->
              <template v-slot:option="option">
                {{ option.seq }}. {{ option.nameLocal }}
              </template>

            </v-select>
          </div>

        </template>

        <template slot="header">
          <vx-tooltip :text="$t('general.back')">
            <vs-button
              @click="onBackClick"
              class="ml-2" color="success" icon="icon-arrow-left" icon-pack="feather" radius
              type="filled"></vs-button>
          </vx-tooltip>
          <vx-tooltip :text="$t('general.add')">
            <vs-button
              @click="onAddClick"
              class="ml-2" color="primary" icon="icon-plus" icon-pack="feather" radius
              type="filled"></vs-button>
          </vx-tooltip>
        </template>

        <template slot="thead"
                  v-for="(thead, indexth) in table.header"
        >
          <vs-th :key="indexth" :sort-key="thead.id" :width="thead.width">
            {{ $t(thead.title) }}
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr
            :data="{ data: tr, index: indextr }"
            :key="indextr"
            v-for="(tr, indextr) in data"
          >
            <vs-td v-html="tr.question" width="380">
              {{ tr.question }}
            </vs-td>
            <vs-td v-html="tr.answer" width="380">
            </vs-td>
            <vs-td class="text-right">
              {{ tr.hitRateCount }}
            </vs-td>
            <vs-td>
              {{ formatDate(tr.updatedAt) }}
              <br>
              {{ formatTime(tr.updatedAt) }}
            </vs-td>

            <vs-td class="whitespace-no-wrap" width="50">
              <feather-icon @click="onEditClick(tr)" class="mr-2"
                            icon="EditIcon"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
              <feather-icon @click="onDeleteClick(tr)" icon="TrashIcon"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table-mod>

    </vx-card>

  </div>
</template>

<script>
  import store from '../../../../store';
  import moment from 'moment';
  import {tableConfig} from '../../../../utils/table'
  import {dateTimeFormat} from '../../../../utils/format';
  import {getAvatarUrl} from "../../../../utils/upload";
  import {confirmDelete} from "../../../../utils/dialogs";
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";
  import CourseFaq from '../../../../store/modules/class-room/course-faq/index';
  import CourseOutline from '../../../../store/modules/courses/course-outline/index';
  import vSelect from "vue-select";
  import CardSubjectInfo from "../../../../components/shared/card/CardSubjectInfo";

  if (!store.state.CourseFaq) store.state.registerModule(`CourseFaq`, CourseFaq);
  if (!store.state.CourseOutline) store.state.registerModule(`CourseOutline`, CourseOutline);

  const {
    mapActions: mapCourseFaqActions,
  } = createNamespacedHelpers(`CourseFaq`);
  const {
    mapActions: mapCourseOutlineActions,
  } = createNamespacedHelpers(`CourseOutline`);

  const {
    mapFields: mapCourseFaqFields,
  } = createHelpers({
    getterType: `CourseFaq/getField`,
    mutationType: `CourseFaq/updateField`,
  });
  const {
    mapFields: mapCourseOutlineFields,
  } = createHelpers({
    getterType: `CourseOutline/getField`,
    mutationType: `CourseOutline/updateField`,
  });

  export default {
    components: {
      vSelect,
      Loader: () => import('@/components/common-ui/loader-block/index.vue'),
      vsTableMod: () => import('@/components/vuesax-mod/components/vsTable/vsTable.vue'),
      CardSubjectInfo,
    },
    data() {
      return {
        table: {
          header: [
            {title: 'course-faq.question', id: 'question'},
            {title: 'course-faq.answer', id: 'answer'},
            {title: 'course-faq.hit-count', id: 'hitRateCount'},
            {title: 'course-faq.updated-date', id: 'updatedAt'},
            {title: 'general.manage', id: 'Actions'},
          ]
        },
        tableConfig: tableConfig,

        moment: moment,
        dateTimeFormat: dateTimeFormat,
        getAvatarUrl: getAvatarUrl,
        courseOutlineUnits: [],
        selectCourseOutlineUnit: null,
      }
    },
    computed: {
      ...mapCourseFaqFields({
        courseFaqs: 'courseFaqs',
        courseFaqProcessing: 'processing',
        courseFaqError: 'error',
        courseFaqSuccess: 'success'
      }),
      ...mapCourseOutlineFields({
        courseOutlineProcessing: 'processing',
      }),
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapCourseFaqActions({
        getCourseFaqsByFilterCurrentTeacher: 'getCourseFaqsByFilterCurrentTeacher',
        deleteCourseFaq: 'deleteCourseFaq',
      }),
      ...mapCourseOutlineActions({
        getCourseOutlineUnitsByCourseOutlineId: 'getCourseOutlineUnitsByCourseOutlineId',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onAddClick() {
        this.$router.push({
          path: `/course-faq-add/${this.$route.params.classSectionId}/${this.$route.params.courseOutlineId}/${this.selectCourseOutlineUnit.id}`,
          params: {
            courseOutlineUnitId: this.selectCourseOutlineUnit.id,
            classSectionId: this.$route.params.classSectionId,
          }
        });
      },
      onEditClick(tr) {
        this.$router.push({
          path: `/course-faq-edit/${this.$route.params.classSectionId}/${this.$route.params.courseOutlineId}/${this.selectCourseOutlineUnit.id}/${tr.id}`,
          params: {
            courseOutlineUnitId: this.selectCourseOutlineUnit.id,
            classSectionId: this.$route.params.classSectionId,
            id: tr.id,
          }
        });
      },
      async onDeleteClick(tr) {
        let payload = {
          id: tr.id,
        }
        await confirmDelete(this.$vs, this.removeCourseFaq, payload);
      },
      onBackClick() {
        this.$router.push({
          name: 'home',
        })
      },
      async onCourseOutlineUnitChange() {
        await this.filterData()
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      formatDate(date) {
        if (date) {
          return moment.utc(date).format(dateTimeFormat.momentYYYYMMDD)
        }
        return '-'
      },
      formatTime(date) {
        if (date) {
          return moment.utc(date).format(dateTimeFormat.momenthhmmsss)
        }
        return '-'
      },
      async removeCourseFaq(payload) {
        await this.deleteCourseFaq(payload);
        await this.loadData();
      },
      async initData() {
        const payload = {
          courseOutlineId: this.$route.params.courseOutlineId,
        };
        this.courseOutlineUnits = await this.getCourseOutlineUnitsByCourseOutlineId(payload);
        if (this.courseOutlineUnits && this.courseOutlineUnits.length > 0) {
          this.selectCourseOutlineUnit = this.courseOutlineUnits[0]
        }
      },
      async loadData() {
        await this.filterData();
      },
      async filterData() {
        let payload = {
          courseFAQFilterInput: {
            // classSectionId: this.$route.params.classSectionId,
            courseOutlineUnitId: this.selectCourseOutlineUnit.id,
          }
        };
        await this.getCourseFaqsByFilterCurrentTeacher(payload);
      },
    },
    async beforeMount() {
      await this.initData();
      await this.loadData();
    }
  }
</script>

<style scoped>

</style>

